export interface Country {
  isoCode: string;
  name: string;
  dialCode: number;
}

export const DEFAULT_PHONE_ISO_CODE = 'IN';

export const COUNTRIES: Country[] = [
  { isoCode: 'AF', name: 'Afghanistan', dialCode: 93 },
  { isoCode: 'AX', name: 'Åland Islands', dialCode: 358 },
  { isoCode: 'AL', name: 'Albania', dialCode: 355 },
  { isoCode: 'DZ', name: 'Algeria', dialCode: 213 },
  { isoCode: 'AS', name: 'American Samoa', dialCode: 1 },
  { isoCode: 'AD', name: 'Andorra', dialCode: 376 },
  { isoCode: 'AO', name: 'Angola', dialCode: 244 },
  { isoCode: 'AI', name: 'Anguilla', dialCode: 1 },
  { isoCode: 'AQ', name: 'Antarctica', dialCode: 672 },
  { isoCode: 'AG', name: 'Antigua and Barbuda', dialCode: 1 },
  { isoCode: 'AR', name: 'Argentina', dialCode: 54 },
  { isoCode: 'AM', name: 'Armenia', dialCode: 374 },
  { isoCode: 'AW', name: 'Aruba', dialCode: 297 },
  { isoCode: 'AU', name: 'Australia', dialCode: 61 },
  { isoCode: 'AT', name: 'Austria', dialCode: 43 },
  { isoCode: 'AZ', name: 'Azerbaijan', dialCode: 994 },
  { isoCode: 'BS', name: 'Bahamas', dialCode: 1 },
  { isoCode: 'BH', name: 'Bahrain', dialCode: 973 },
  { isoCode: 'BD', name: 'Bangladesh', dialCode: 880 },
  { isoCode: 'BB', name: 'Barbados', dialCode: 1 },
  { isoCode: 'BY', name: 'Belarus', dialCode: 375 },
  { isoCode: 'BE', name: 'Belgium', dialCode: 32 },
  { isoCode: 'BZ', name: 'Belize', dialCode: 501 },
  { isoCode: 'BJ', name: 'Benin', dialCode: 229 },
  { isoCode: 'BM', name: 'Bermuda', dialCode: 1 },
  { isoCode: 'BT', name: 'Bhutan', dialCode: 975 },
  { isoCode: 'BO', name: 'Bolivia (Plurinational State of)', dialCode: 591 },
  { isoCode: 'BA', name: 'Bosnia and Herzegovina', dialCode: 387 },
  { isoCode: 'BW', name: 'Botswana', dialCode: 267 },
  { isoCode: 'BV', name: 'Bouvet Island', dialCode: 55 },
  { isoCode: 'BR', name: 'Brazil', dialCode: 55 },
  { isoCode: 'IO', name: 'British Indian Ocean Territory', dialCode: 246 },
  { isoCode: 'BN', name: 'Brunei Darussalam', dialCode: 673 },
  { isoCode: 'BG', name: 'Bulgaria', dialCode: 359 },
  { isoCode: 'BF', name: 'Burkina Faso', dialCode: 226 },
  { isoCode: 'BI', name: 'Burundi', dialCode: 257 },
  { isoCode: 'CV', name: 'Cabo Verde', dialCode: 238 },
  { isoCode: 'KH', name: 'Cambodia', dialCode: 855 },
  { isoCode: 'CM', name: 'Cameroon', dialCode: 237 },
  { isoCode: 'CA', name: 'Canada', dialCode: 1 },
  { isoCode: 'BQ', name: 'Caribbean Netherlands', dialCode: 599 },
  { isoCode: 'KY', name: 'Cayman Islands', dialCode: 1 },
  { isoCode: 'CF', name: 'Central African Republic', dialCode: 236 },
  { isoCode: 'TD', name: 'Chad', dialCode: 235 },
  { isoCode: 'CL', name: 'Chile', dialCode: 56 },
  { isoCode: 'CN', name: 'China', dialCode: 86 },
  { isoCode: 'CX', name: 'Christmas Island', dialCode: 61 },
  { isoCode: 'CC', name: 'Cocos (Keeling) Islands', dialCode: 61 },
  { isoCode: 'CO', name: 'Colombia', dialCode: 57 },
  { isoCode: 'KM', name: 'Comoros', dialCode: 269 },
  { isoCode: 'CG', name: 'Congo', dialCode: 242 },
  { isoCode: 'CD', name: 'Congo, Democratic Republic of the', dialCode: 243 },
  { isoCode: 'CK', name: 'Cook Islands', dialCode: 682 },
  { isoCode: 'CR', name: 'Costa Rica', dialCode: 506 },
  { isoCode: 'HR', name: 'Croatia', dialCode: 385 },
  { isoCode: 'CU', name: 'Cuba', dialCode: 53 },
  { isoCode: 'CW', name: 'Curaçao', dialCode: 599 },
  { isoCode: 'CY', name: 'Cyprus', dialCode: 357 },
  { isoCode: 'CZ', name: 'Czech Republic', dialCode: 420 },
  { isoCode: 'CI', name: "Côte d'Ivoire", dialCode: 225 },
  { isoCode: 'DK', name: 'Denmark', dialCode: 45 },
  { isoCode: 'DJ', name: 'Djibouti', dialCode: 253 },
  { isoCode: 'DM', name: 'Dominica', dialCode: 1 },
  { isoCode: 'DO', name: 'Dominican Republic', dialCode: 1 },
  { isoCode: 'EC', name: 'Ecuador', dialCode: 593 },
  { isoCode: 'EG', name: 'Egypt', dialCode: 20 },
  { isoCode: 'SV', name: 'El Salvador', dialCode: 503 },
  { isoCode: 'GQ', name: 'Equatorial Guinea', dialCode: 240 },
  { isoCode: 'ER', name: 'Eritrea', dialCode: 291 },
  { isoCode: 'EE', name: 'Estonia', dialCode: 372 },
  { isoCode: 'SZ', name: 'Eswatini (Swaziland)', dialCode: 268 },
  { isoCode: 'ET', name: 'Ethiopia', dialCode: 251 },
  { isoCode: 'FK', name: 'Falkland Islands (Malvinas)', dialCode: 500 },
  { isoCode: 'FO', name: 'Faroe Islands', dialCode: 298 },
  { isoCode: 'FJ', name: 'Fiji', dialCode: 679 },
  { isoCode: 'FI', name: 'Finland', dialCode: 358 },
  { isoCode: 'FR', name: 'France', dialCode: 33 },
  { isoCode: 'GF', name: 'French Guiana', dialCode: 594 },
  { isoCode: 'PF', name: 'French Polynesia', dialCode: 689 },
  { isoCode: 'TF', name: 'French Southern Territories', dialCode: 262 },
  { isoCode: 'GA', name: 'Gabon', dialCode: 241 },
  { isoCode: 'GM', name: 'Gambia', dialCode: 220 },
  { isoCode: 'GE', name: 'Georgia', dialCode: 995 },
  { isoCode: 'DE', name: 'Germany', dialCode: 49 },
  { isoCode: 'GH', name: 'Ghana', dialCode: 233 },
  { isoCode: 'GI', name: 'Gibraltar', dialCode: 350 },
  { isoCode: 'GR', name: 'Greece', dialCode: 30 },
  { isoCode: 'GL', name: 'Greenland', dialCode: 299 },
  { isoCode: 'GD', name: 'Grenada', dialCode: 1 },
  { isoCode: 'GP', name: 'Guadeloupe', dialCode: 590 },
  { isoCode: 'GU', name: 'Guam', dialCode: 1 },
  { isoCode: 'GT', name: 'Guatemala', dialCode: 502 },
  { isoCode: 'GG', name: 'Guernsey', dialCode: 44 },
  { isoCode: 'GN', name: 'Guinea', dialCode: 224 },
  { isoCode: 'GW', name: 'Guinea-Bissau', dialCode: 245 },
  { isoCode: 'GY', name: 'Guyana', dialCode: 592 },
  { isoCode: 'HT', name: 'Haiti', dialCode: 509 },
  { isoCode: 'HM', name: 'Heard Island and Mcdonald Islands', dialCode: 61 },
  { isoCode: 'HN', name: 'Honduras', dialCode: 504 },
  { isoCode: 'HK', name: 'Hong Kong', dialCode: 852 },
  { isoCode: 'HU', name: 'Hungary', dialCode: 36 },
  { isoCode: 'IS', name: 'Iceland', dialCode: 354 },
  { isoCode: 'IN', name: 'India', dialCode: 91 },
  { isoCode: 'ID', name: 'Indonesia', dialCode: 62 },
  { isoCode: 'IR', name: 'Iran', dialCode: 98 },
  { isoCode: 'IQ', name: 'Iraq', dialCode: 964 },
  { isoCode: 'IE', name: 'Ireland', dialCode: 353 },
  { isoCode: 'IM', name: 'Isle of Man', dialCode: 44 },
  { isoCode: 'IL', name: 'Israel', dialCode: 972 },
  { isoCode: 'IT', name: 'Italy', dialCode: 39 },
  { isoCode: 'JM', name: 'Jamaica', dialCode: 1 },
  { isoCode: 'JP', name: 'Japan', dialCode: 81 },
  { isoCode: 'JE', name: 'Jersey', dialCode: 44 },
  { isoCode: 'JO', name: 'Jordan', dialCode: 962 },
  { isoCode: 'KZ', name: 'Kazakhstan', dialCode: 7 },
  { isoCode: 'KE', name: 'Kenya', dialCode: 254 },
  { isoCode: 'KI', name: 'Kiribati', dialCode: 686 },
  { isoCode: 'KP', name: 'Korea, North', dialCode: 850 },
  { isoCode: 'KR', name: 'Korea, South', dialCode: 82 },
  { isoCode: 'XK', name: 'Kosovo', dialCode: 383 },
  { isoCode: 'KW', name: 'Kuwait', dialCode: 965 },
  { isoCode: 'KG', name: 'Kyrgyzstan', dialCode: 996 },
  { isoCode: 'LA', name: "Lao People's Democratic Republic", dialCode: 856 },
  { isoCode: 'LV', name: 'Latvia', dialCode: 371 },
  { isoCode: 'LB', name: 'Lebanon', dialCode: 961 },
  { isoCode: 'LS', name: 'Lesotho', dialCode: 266 },
  { isoCode: 'LR', name: 'Liberia', dialCode: 231 },
  { isoCode: 'LY', name: 'Libya', dialCode: 218 },
  { isoCode: 'LI', name: 'Liechtenstein', dialCode: 423 },
  { isoCode: 'LT', name: 'Lithuania', dialCode: 370 },
  { isoCode: 'LU', name: 'Luxembourg', dialCode: 352 },
  { isoCode: 'MO', name: 'Macao', dialCode: 853 },
  { isoCode: 'MK', name: 'Macedonia North', dialCode: 389 },
  { isoCode: 'MG', name: 'Madagascar', dialCode: 261 },
  { isoCode: 'MW', name: 'Malawi', dialCode: 265 },
  { isoCode: 'MY', name: 'Malaysia', dialCode: 60 },
  { isoCode: 'MV', name: 'Maldives', dialCode: 960 },
  { isoCode: 'ML', name: 'Mali', dialCode: 223 },
  { isoCode: 'MT', name: 'Malta', dialCode: 356 },
  { isoCode: 'MH', name: 'Marshall Islands', dialCode: 692 },
  { isoCode: 'MQ', name: 'Martinique', dialCode: 596 },
  { isoCode: 'MR', name: 'Mauritania', dialCode: 222 },
  { isoCode: 'MU', name: 'Mauritius', dialCode: 230 },
  { isoCode: 'YT', name: 'Mayotte', dialCode: 262 },
  { isoCode: 'MX', name: 'Mexico', dialCode: 52 },
  { isoCode: 'FM', name: 'Micronesia', dialCode: 691 },
  { isoCode: 'MD', name: 'Moldova', dialCode: 373 },
  { isoCode: 'MC', name: 'Monaco', dialCode: 377 },
  { isoCode: 'MN', name: 'Mongolia', dialCode: 976 },
  { isoCode: 'ME', name: 'Montenegro', dialCode: 382 },
  { isoCode: 'MS', name: 'Montserrat', dialCode: 1 },
  { isoCode: 'MA', name: 'Morocco', dialCode: 212 },
  { isoCode: 'MZ', name: 'Mozambique', dialCode: 258 },
  { isoCode: 'MM', name: 'Myanmar (Burma)', dialCode: 95 },
  { isoCode: 'NA', name: 'Namibia', dialCode: 264 },
  { isoCode: 'NR', name: 'Nauru', dialCode: 674 },
  { isoCode: 'NP', name: 'Nepal', dialCode: 977 },
  { isoCode: 'NL', name: 'Netherlands', dialCode: 31 },
  { isoCode: 'AN', name: 'Netherlands Antilles', dialCode: 599 },
  { isoCode: 'NC', name: 'New Caledonia', dialCode: 687 },
  { isoCode: 'NZ', name: 'New Zealand', dialCode: 64 },
  { isoCode: 'NI', name: 'Nicaragua', dialCode: 505 },
  { isoCode: 'NE', name: 'Niger', dialCode: 227 },
  { isoCode: 'NG', name: 'Nigeria', dialCode: 234 },
  { isoCode: 'NU', name: 'Niue', dialCode: 683 },
  { isoCode: 'NF', name: 'Norfolk Island', dialCode: 672 },
  { isoCode: 'MP', name: 'Northern Mariana Islands', dialCode: 1 },
  { isoCode: 'NO', name: 'Norway', dialCode: 47 },
  { isoCode: 'OM', name: 'Oman', dialCode: 968 },
  { isoCode: 'PK', name: 'Pakistan', dialCode: 92 },
  { isoCode: 'PW', name: 'Palau', dialCode: 680 },
  { isoCode: 'PS', name: 'Palestine', dialCode: 970 },
  { isoCode: 'PA', name: 'Panama', dialCode: 507 },
  { isoCode: 'PG', name: 'Papua New Guinea', dialCode: 675 },
  { isoCode: 'PY', name: 'Paraguay', dialCode: 595 },
  { isoCode: 'PE', name: 'Peru', dialCode: 51 },
  { isoCode: 'PH', name: 'Philippines', dialCode: 63 },
  { isoCode: 'PN', name: 'Pitcairn Islands', dialCode: 64 },
  { isoCode: 'PL', name: 'Poland', dialCode: 48 },
  { isoCode: 'PT', name: 'Portugal', dialCode: 351 },
  { isoCode: 'PR', name: 'Puerto Rico', dialCode: 1 },
  { isoCode: 'QA', name: 'Qatar', dialCode: 974 },
  { isoCode: 'RE', name: 'Reunion', dialCode: 262 },
  { isoCode: 'RO', name: 'Romania', dialCode: 40 },
  { isoCode: 'RU', name: 'Russian Federation', dialCode: 7 },
  { isoCode: 'RW', name: 'Rwanda', dialCode: 250 },
  { isoCode: 'BL', name: 'Saint Barthelemy', dialCode: 590 },
  { isoCode: 'SH', name: 'Saint Helena', dialCode: 290 },
  { isoCode: 'KN', name: 'Saint Kitts and Nevis', dialCode: 1 },
  { isoCode: 'LC', name: 'Saint Lucia', dialCode: 1 },
  { isoCode: 'MF', name: 'Saint Martin', dialCode: 590 },
  { isoCode: 'PM', name: 'Saint Pierre and Miquelon', dialCode: 508 },
  { isoCode: 'VC', name: 'Saint Vincent and the Grenadines', dialCode: 1 },
  { isoCode: 'WS', name: 'Samoa', dialCode: 685 },
  { isoCode: 'SM', name: 'San Marino', dialCode: 378 },
  { isoCode: 'ST', name: 'Sao Tome and Principe', dialCode: 239 },
  { isoCode: 'SA', name: 'Saudi Arabia', dialCode: 966 },
  { isoCode: 'SN', name: 'Senegal', dialCode: 221 },
  { isoCode: 'RS', name: 'Serbia', dialCode: 381 },
  { isoCode: 'CS', name: 'Serbia and Montenegro', dialCode: 381 },
  { isoCode: 'SC', name: 'Seychelles', dialCode: 248 },
  { isoCode: 'SL', name: 'Sierra Leone', dialCode: 232 },
  { isoCode: 'SG', name: 'Singapore', dialCode: 65 },
  { isoCode: 'SX', name: 'Sint Maarten', dialCode: 1 },
  { isoCode: 'SK', name: 'Slovakia', dialCode: 421 },
  { isoCode: 'SI', name: 'Slovenia', dialCode: 386 },
  { isoCode: 'SB', name: 'Solomon Islands', dialCode: 677 },
  { isoCode: 'SO', name: 'Somalia', dialCode: 252 },
  { isoCode: 'ZA', name: 'South Africa', dialCode: 27 },
  {
    isoCode: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    dialCode: 500,
  },
  { isoCode: 'SS', name: 'South Sudan', dialCode: 211 },
  { isoCode: 'ES', name: 'Spain', dialCode: 34 },
  { isoCode: 'LK', name: 'Sri Lanka', dialCode: 94 },
  { isoCode: 'SD', name: 'Sudan', dialCode: 249 },
  { isoCode: 'SR', name: 'Suriname', dialCode: 597 },
  { isoCode: 'SJ', name: 'Svalbard and Jan Mayen', dialCode: 47 },
  { isoCode: 'SE', name: 'Sweden', dialCode: 46 },
  { isoCode: 'CH', name: 'Switzerland', dialCode: 41 },
  { isoCode: 'SY', name: 'Syria', dialCode: 963 },
  { isoCode: 'TW', name: 'Taiwan', dialCode: 886 },
  { isoCode: 'TJ', name: 'Tajikistan', dialCode: 992 },
  { isoCode: 'TZ', name: 'Tanzania', dialCode: 255 },
  { isoCode: 'TH', name: 'Thailand', dialCode: 66 },
  { isoCode: 'TL', name: 'Timor-Leste', dialCode: 670 },
  { isoCode: 'TG', name: 'Togo', dialCode: 228 },
  { isoCode: 'TK', name: 'Tokelau', dialCode: 690 },
  { isoCode: 'TO', name: 'Tonga', dialCode: 676 },
  { isoCode: 'TT', name: 'Trinidad and Tobago', dialCode: 1 },
  { isoCode: 'TN', name: 'Tunisia', dialCode: 216 },
  { isoCode: 'TR', name: 'Turkey (Türkiye)', dialCode: 90 },
  { isoCode: 'TM', name: 'Turkmenistan', dialCode: 993 },
  { isoCode: 'TC', name: 'Turks and Caicos Islands', dialCode: 1 },
  { isoCode: 'TV', name: 'Tuvalu', dialCode: 688 },
  { isoCode: 'UM', name: 'U.S. Outlying Islands', dialCode: 1 },
  { isoCode: 'UG', name: 'Uganda', dialCode: 256 },
  { isoCode: 'UA', name: 'Ukraine', dialCode: 380 },
  { isoCode: 'AE', name: 'United Arab Emirates', dialCode: 971 },
  { isoCode: 'GB', name: 'United Kingdom', dialCode: 44 },
  { isoCode: 'US', name: 'United States', dialCode: 1 },
  { isoCode: 'UY', name: 'Uruguay', dialCode: 598 },
  { isoCode: 'UZ', name: 'Uzbekistan', dialCode: 998 },
  { isoCode: 'VU', name: 'Vanuatu', dialCode: 678 },
  { isoCode: 'VA', name: 'Vatican City Holy See', dialCode: 39 },
  { isoCode: 'VE', name: 'Venezuela', dialCode: 58 },
  { isoCode: 'VN', name: 'Vietnam', dialCode: 84 },
  { isoCode: 'VG', name: 'Virgin Islands, British', dialCode: 1 },
  { isoCode: 'VI', name: 'Virgin Islands, U.S', dialCode: 1 },
  { isoCode: 'WF', name: 'Wallis and Futuna', dialCode: 681 },
  { isoCode: 'EH', name: 'Western Sahara', dialCode: 212 },
  { isoCode: 'YE', name: 'Yemen', dialCode: 967 },
  { isoCode: 'ZM', name: 'Zambia', dialCode: 260 },
  { isoCode: 'ZW', name: 'Zimbabwe', dialCode: 263 },
];

export function formatCountryDialCode(dialCode: number): string {
  return dialCode > 0 ? `+${dialCode}` : '+0';
}

export function getDialCodeByIsoCode(isoCode: string): number | undefined {
  return COUNTRIES.find(country => country.isoCode === isoCode)?.dialCode;
}
